import { createTheme } from "../theme/theme";

export const smartrent = createTheme({
  name: "smartrent",
});
